<template>
<!-- eslint-disable max-len -->
<p
  v-if="starfighter"
  class="narrator-panel sf"
  :style="style"
>
  <span class="image-text">
    <img v-if="icon" :src="resolveAssetPath(icon, 'characters')">
    <span class="message" :class="{ 'no-image': !icon }"><slot></slot></span>
  </span>

  <transition enter-active-class="animated fadeIn">
    <div v-if="to || next || back" style="display: flex; flex-flow: row nowrap; justify-content: center; align-items: center;">
      <div class="navigate-button-wrapper">
        <button
          v-if="back"
          class="btn back-btn"
          @click.prevent="onBack"
          v-b-tooltip.hover.bottomright
          :title="
            (narrative && narrative.backButtonText)
              ? narrative.backButtonText
              : ((game && game.backButtonDefaultText) ? game.backButtonDefaultText : 'Back')
          "
        >
          <!-- <slot name="back">
            <span v-html="(narrative && narrative.backButtonText) ? narrative.backButtonText : ((game && game.backButtonDefaultText) ? game.backButtonDefaultText : 'Back')"></span>
          </slot> -->
        </button>
      </div>
      <div class="navigate-button-wrapper">
        <button v-if="to || next" class="btn next-btn" @click.prevent="navigate" v-focus="!noFocus">
          <slot name="button">
            <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
          </slot>
        </button>
      </div>
    </div>
  </transition>
</p>
<sliced-box
  v-else
  class="narrator-panel native"
  :style="style"
>
  <span class="image-text">
    <img v-if="icon" :src="resolveAssetPath(icon, 'characters')">
    <span class="message" :class="{ 'no-image': !icon }"><slot></slot></span>
  </span>

  <transition enter-active-class="animated fadeIn">
    <button v-if="to || next" class="btn" @click.prevent="navigate" v-focus="!noFocus">
      <slot name="button">
        <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
      </slot>
    </button>
  </transition>
</sliced-box>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import SlicedBox from '../ui/SlicedBox';

export default {
  components: {
    SlicedBox
  },
  props: {
    to: { type: String },
    replace: { type: Boolean },
    next: { type: Function },
    back: { type: Function },
    noFocus: { type: Boolean },
    width: { type: Number },
    minHeight: { type: String },
    character: { type: Object },
    player: { type: Boolean }
  },
  computed: {
    ...mapGetters([
      'selectedAvatar',
      'narrative',
      'game',
      'starfighter',
      'native'
    ]),
    char() {
      return this.player && this.selectedAvatar || this.character || {};
    },
    icon() {
      let variantName = '';
      if (this.narrative != null && this.char != null
        && this.char.imageVariants && this.char.imageVariants.length > 0
        && this.narrative.centerVariant) {
        variantName = this.narrative.centerVariant;
      }
      if (variantName) {
        const variant = this.char.imageVariants.find(v => v.name === variantName);
        if (variant) {
          return variant.image;
        }
      }
      return this.char.icon;
    },
    style() {
      let leftVal = '30px';
      let bottomVal = '15px';

      const totalXoffset = this.narrative.panelXOffset;
      const totalYoffset = this.narrative.panelYOffset;

      if (totalXoffset) leftVal = `calc(${leftVal} + ${totalXoffset})`;

      if (totalYoffset) bottomVal = `calc(${bottomVal} + ${totalYoffset})`;

      return {
        width: this.width || '1540px',
        'min-height': (this.minHeight ? this.minHeight : undefined),
        left: leftVal,
        bottom: bottomVal,
      };
    }
  },
  methods: {
    ...mapActions([
      'playSound',
    ]),
    playClick() {
      this.playSound({
        sound:
          this.game.nextButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
      });
    },
    playBackClick() {
      this.playSound({
        sound:
          this.game.backButtonSound
          || this.game.clickSoundOverride
          || this.resolveAssetPath('click_cut.mp3', 'ui/customer'),
      });
    },
    navigate() {
      this.playClick();
      if (this.next) {
        this.next();
      } else if (this.to) {
        if (this.replace) this.$router.replace(this.to);
        else this.$router.push(this.to);
      }
    },
    onBack() {
      this.playBackClick();
      if (this.back) {
        this.back();
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.narrator-panel {
  position: absolute;
  padding: 20px 17px 20px 35px;
  margin: 0;
  font-size: 32px;
  // font-weight: bold;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  min-height: 166px;
}
.narrator-panel.sf {
  background-color: white;
  border: 4px solid white;
  border-radius: 2px;
  z-index: 10;
}
.narrator-panel.native {
  .message {
    margin: -50px -32px;
  }
}
.image-text {
  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: center;
}
.narrator-panel img {
  float: left;
  height: 175px;
  margin-right: 50px;
  background-color: var(--narratorIconBackgroundColor);
}
.narrator-panel .btn {
  font-size: 40px;
  padding: 8px 10px;
  min-width: 280px;
  min-height: 80px;
}
.narrator-panel .next-btn {
  font-size: 40px;
  padding-right: 42px;
  min-width: 279px;
  width: 279px;
  animation: none;
  mask: url('../../../assets/ui/mask2_next.png') center/contain;
  mask-repeat: no-repeat;
}
.narrator-panel .back-btn {
  min-width: 84px;
  width: 84px;
  margin-right: 4px;
  animation: none;
  mask: url('../../../assets/ui/mask2_back.png') center/contain;
  mask-repeat: no-repeat;
}
.navigate-button-wrapper:focus-within {
  animation: focus-anim 2s infinite cubic-bezier(0.445, 0.05, 0.55, 0.95);
  animation-delay: 0.25s;
}
.narrator-panel.native button {
  position: absolute;
  right: -54px;
  bottom: -30px;
}
.message {
  padding-right: 15px;
  min-width: 850px;
  max-width: 850px;
}
.message.no-image {
  max-width: 1100px;
}

@keyframes focus-anim {
  0% {
    filter: none;
  }

  50% {
    filter:
      drop-shadow(0px 0px 5px var(--primaryBorderColor))
      drop-shadow(0px 0px 6px var(--primaryBorderColor));
  }

  100% {
    filter:
      drop-shadow(0px 0px 10px transparent)
      drop-shadow(0px 0px 12px transparent);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/ui/NarratorPanel.vue